
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Tag, Flex, FlexItem, FlexJustify, Size, Margin, Color } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Tag`}</h1>
<p>{`Used to display a status, or a category, but in a more compact way. Tag colors are also lighter, since more than one can be placed together, unlike `}<inlineCode parentName="p">{`Status`}</inlineCode>{` which should be standalone.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Tag } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Tag>Content</Tag>`} component={Tag} mdxType="Playground">
  <Tag mdxType="Tag">Content</Tag>
</Playground>
<p>{`If you pass a `}<inlineCode parentName="p">{`onClickRemove`}</inlineCode>{` function, then a "x" is shown:`}</p>
<Playground __position={1} __code={`<Flex justify={FlexJustify.START}>
  <FlexItem>
    <Margin size={{ right: Size.EXTRA_SMALL }}>
      <Tag onClickRemove={x=>x}>Removable</Tag>
    </Margin>
  </FlexItem>
  <FlexItem>
    <Tag onClickRemove={() => console.log('clicked')} inversed>Another one</Tag>
  </FlexItem>
</Flex>`} mdxType="Playground">
  <Flex justify={FlexJustify.START} mdxType="Flex">
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.EXTRA_SMALL
          }} mdxType="Margin">
        <Tag onClickRemove={x => x} mdxType="Tag">Removable</Tag>
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Tag onClickRemove={() => console.log('clicked')} inversed mdxType="Tag">Another one</Tag>
    </FlexItem>
  </Flex>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;